import React, {Component} from 'react'
// import { connect } from 'react-redux'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

class PostPaymentPopup extends Popup {
    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.userClosable = true;
        this.afterClosePositionReset = false;
    }

    render() {
        let lang = Registry.get('locale');

        let className = 'popup popup-post-payment ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <p dangerouslySetInnerHTML={{__html:lang.post_payment_text}}/>
                <div className="buttons">
                    <a className="popup-button close" onClick={() => this.close()}>{lang.close}</a>
                </div>
             </div>
        )
    }

}

PostPaymentPopup.generateKey = function(props) { return 'popup-post-payment' };
PostPaymentPopup.mount = function(props, onMount) { Popup.mount(PostPaymentPopup, props, onMount) };
PostPaymentPopup.open = function(id) {
    PostPaymentPopup.mount({id}, () => Popup.popups[PostPaymentPopup.generateKey()].open());   
};

export default PostPaymentPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PostPaymentPopup/index.js